import * as ex from 'excalibur';
import { GridPosition } from '../types/interfaces';

// Game configuration
export const TILE_SIZE = 40;
export const GRID_WIDTH = 15;
export const GRID_HEIGHT = 10;

// Direction constants
export const DIRECTIONS = {
  UP: { x: 0, y: -1 },
  DOWN: { x: 0, y: 1 },
  LEFT: { x: -1, y: 0 },
  RIGHT: { x: 1, y: 0 }
};

// Get all 8 directions including diagonals
export const getAllDirections = (): GridPosition[] => [
  DIRECTIONS.UP,
  DIRECTIONS.DOWN,
  DIRECTIONS.LEFT,
  DIRECTIONS.RIGHT,
  { x: -1, y: -1 }, // UP-LEFT
  { x: 1, y: -1 },  // UP-RIGHT
  { x: -1, y: 1 },  // DOWN-LEFT
  { x: 1, y: 1 }    // DOWN-RIGHT
];

// Animation configuration
export const ANIMATION_DURATION = 150; // milliseconds
export const DEBUG_COLOR = ex.Color.fromHex('#ffcc0033'); // Yellow with transparency for cell examination highlights